module.exports = __webpack_public_path__ + "static/media/DSC07449.4b2a29a8.JPG";